import React from 'react';
import wb0 from '../img/Detail/story_detail.jpg';
import './Detail.css';
const StoryDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={wb0} alt="Kuş" />
    </div>
    
  );
};

export default StoryDetail;